import { Box, Button, Modal, Typography, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import style from "../../../../styles/common/formModal.module.css";
import { formatDate } from "../../../../utils/formatDate";
import Drawer from "@mui/material/Drawer";
import DocumentItem from "../../../../Components/Masters/DocumentItem";
import { truncateNumber } from "../../../../utils/common";

const View = ({
  isOpen,
  onClose,
  header,
  initialData,
  handleEdit,
  companyAdmin,
}) => {
  const handleCancel = () => {
    onClose();
  };
  console.log(initialData, "initialData");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleCancel} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          Ship Transportation and Distrubution Details
        </Typography>
        <Box>
          <Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Date
              </Typography>

              <p>
                {new Date(initialData?.createdAt).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }) ?? ""}
                {/* {new Date(initialData?.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) ?? ""} */}
              </p>
            </Box>
            <Box>
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                Consumption Month
              </Typography>

              <p>
                {`${
                  monthNames[(initialData?.consumptionPeriod?.month ?? 1) - 1]
                } ${initialData?.consumptionPeriod?.year ?? ""}`}
              </p>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Transportation Type
            </Typography>
            <p> {initialData?.transportationType ?? ""}</p>
            {/* <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold" }}
            >
              Travel Type
            </Typography>
              <p> {initialData??.travelType ?? ""}</p>

              <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold" }}
            >
              Class Type
            </Typography>
              <p> {initialData??.className ?? ""}</p> */}
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Source
            </Typography>
            <p> {initialData?.origin ?? ""}</p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Destination
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {initialData?.destination ?? ""}
            </p>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Shipment Category
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {initialData?.categoryOfShipment ?? ""}
            </p>
          </Box>

          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Shipment Type
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {initialData?.typeOfShipment ?? ""}
            </p>
          </Box>
        </Box>
        <Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Freight Load (Tonnes)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {initialData?.freightLoad?.value === ""
                ? "-"
                : truncateNumber(initialData?.freightLoad?.value)}
            </p>
          </Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
              Distance Travelled (Km)
            </Typography>
            <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
              {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
              {truncateNumber(initialData?.distanceCovered?.value) ?? ""}
            </p>
          </Box>
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          Remark (optional)
        </Typography>
        {/* <p>{initialData?.remark ?? "-"}</p> */}
        <p>{initialData?.remark?.trim() ? initialData.remark : "-"}</p>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>

          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* {data && data.documents.length > 0 ? ( */}
            {initialData && initialData?.documents?.length > 0 ? (
              <>
                {/* Render Images First */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {initialData?.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>

                {/* Render Other Documents */}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {initialData?.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              </>
            ) : (
              <Typography variant="body2">-</Typography>
            )}
          </Box>
        </Box>

        {!companyAdmin && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={() => initialData?._id !== null && handleEdit(initialData)}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={isOpen}
        onClose={handleCancel}
      >
        {list()}
      </Drawer>
    </div>
  );
};

export default View;
